import { PublicClientApplication } from '@azure/msal-browser';
import React /*, { useState }*/ from 'react'
import { Spinner } from '../Loaders/Loaders'
import { MsalAuthTypes } from './MsalAuthTypes'
import '../Shell/Login/Login.scss'
import useConfig from './useConfig'
import { Link } from 'react-router-dom';

export const msalFunctions = {}
export const MsalLogin = (props) => {
  // const [hasError, setHasError] = useState(false);
  // const [errorMessage, setErrorMessage] = useState("");
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [config] = useConfig(props.authType)

  if (config === undefined) {
    return <Spinner></Spinner>
  }

  const msalConfig =
    props.authType == MsalAuthTypes.AzureActiveDirectory
      ? {
          auth: {
            clientId: config.AzureAdSettings.ClientId,
            authority: config.AzureAdSettings.Authority,
            redirectUri: config.AzureAdSettings.RedirectUri,
          },
          cacheLocation: 'sessionStorage',
        }
      : props.authType == MsalAuthTypes.AzureB2C
      ? {
          auth: {
            clientId: config.AzureB2CSettings.ClientId,
            authority: config.AzureB2CSettings.Authority,
            knownAuthorities: [config.AzureB2CSettings.Domain],
            redirectUri: config.AzureB2CSettings.RedirectUri,
          },
          cacheLocation: 'sessionStorage',
        }
      : {}

  const client = new PublicClientApplication(msalConfig)

  const loginAAD = () => {
    let scopes = { scopes: ['User.Read'] }

    client
      .loginPopup(scopes)
      .then((response) => {
        // setHasError(false);
        // setErrorMessage("");
        props.ndLogin(response.accessToken)
      })
      .catch((error) => {
        switch (error.errorCode) {
          case 'popup_window_error':
            // setHasError(true);
            // setErrorMessage("Your browser doesn't allow popup windows. Please allow popup windows, refresh the page, and try again.");
            break
          default:
            console.error(error)
        }
      })
  }

  const loginB2C = () => {
    let scopes = { scopes: ['openid'] }

    client
      .loginPopup(scopes)
      .then((response) => {
        // setHasError(false)
        // setErrorMessage('')
        props.ndLogin(response.idToken)
      })
      .catch((error) => {
        switch (error.errorCode) {
          case 'popup_window_error':
            // setHasError(true)
            // setErrorMessage(
            //   "Your browser doesn't allow popup windows. Please allow popup windows, refresh the page, and try again."
            // )
            break
          default:
            console.error(error)
        }
      })
  }

  msalFunctions.logout = () => {
    client.logoutPopup()
    sessionStorage.clear()
  }

  return (
    <React.Fragment>
      {props.authType == MsalAuthTypes.AzureActiveDirectory ? (
        <button className="nd-login-button" onClick={loginAAD}>
          State Login
        </button>
      ) : (
        <button className="btn btn-default login-link" onClick={loginB2C}>
          {process.env.LOGIN_LABEL || 'Login'}
        </button>
      )}
    </React.Fragment>
  )
}

export const UnauthorizedLoginInstructions = () => {
    return (
        <div className='centered-content'>
            <p className='navigation-instructions'>Please navigate to the home page and log in.</p>
            <Link to="/">
                <button className='btn btn-raised btn-primary'>Home Page</button>
            </Link>
        </div>)
}